export default __webpack_public_path__ + "98bd30f348d6ba8c3f552909d4d7892d.svg";